module.exports = __webpack_public_path__ + "img/ic_12_workout_white.95d5f22c.svg";